import { ROLE_AUTHORITY_TYPE_ADMIN, ROLE_USER_TYPE_HOST } from '@/constants';

const findMatchingRole = (roles, user) => roles
  .find((item) => Number(item.id) === Number(user.role_id));

export const canAccessHostOrganizationPage = (roles, user) => {
  if (!user || !user.role_id) {
    return false;
  }

  const matchingRole = findMatchingRole(roles, user);

  return matchingRole
    && matchingRole.user_type === ROLE_USER_TYPE_HOST
    && matchingRole.authority_type === ROLE_AUTHORITY_TYPE_ADMIN;
};

export const canCreateProgram = (roles, user) => {
  if (!user || !user.role_id) {
    return false;
  }

  const matchingRole = findMatchingRole(roles, user);

  return matchingRole
    && matchingRole.user_type === ROLE_USER_TYPE_HOST
    && matchingRole.authority_type === ROLE_AUTHORITY_TYPE_ADMIN;
};

export const canDeleteProgram = (roles, user) => {
  if (!user || !user.role_id) {
    return false;
  }

  const matchingRole = findMatchingRole(roles, user);

  return matchingRole
    && matchingRole.user_type === ROLE_USER_TYPE_HOST
    && matchingRole.authority_type === ROLE_AUTHORITY_TYPE_ADMIN;
};

export const canEditProgramHostUser = (roles, user) => {
  if (!user || !user.role_id) {
    return false;
  }

  const matchingRole = findMatchingRole(roles, user);

  return matchingRole
    && matchingRole.user_type === ROLE_USER_TYPE_HOST
    && matchingRole.authority_type === ROLE_AUTHORITY_TYPE_ADMIN;
};
